import { CERTIFICATE_FILTER, CERTIFICATE_KID_LIST, CERTIFICATE_LIST, CLASS_LIST, KID_FILTER, RESET_FILTERS, SEARCH_KID_LIST, SECTION_LIST, STUDENT_LIST } from "../actions/types";

const initialState = {
   kidFilter: {
      programs: [],
      schools: [],
      classes: [],
      sections: [],
      kidIds: []
   },
   certificateFilter: {
      programs: [],
      schools: [],
      classes: [],
      sections: [],
      kidIds: [],
      meritList: []
   },
   list: {},
   certificateList: {},
   kidList: {},
   certificateKidList: {},
   classList: [],
   sectionList: []
}

export default function (state = initialState, action) {

   const { type, payload } = action;
   switch (type) {
      case STUDENT_LIST:
         return { ...state, list: payload }
      case CERTIFICATE_LIST:
         return { ...state, certificateList: payload }
      case SEARCH_KID_LIST:
         return { ...state, kidList: payload }
      case KID_FILTER:
         return { ...state, kidFilter: payload }
      case CERTIFICATE_KID_LIST:
         return { ...state, certificateKidList: payload }
      case CERTIFICATE_FILTER:
         return { ...state, certificateFilter: payload }
      case CLASS_LIST:
         return { ...state, classList: payload }
      case SECTION_LIST:
         return { ...state, sectionList: payload }
      case RESET_FILTERS:
         return {
            ...state, kidFilter: {
               programs: [],
               schools: [],
               classes: [],
               sections: [],
               kidIds: []
            },
            certificateFilter: {
               programs: [],
               schools: [],
               classes: [],
               sections: [],
               kidIds: [],
               meritList: []
            },
         }
      default:
         return state;
   }
}